// src/pages/OwnerPanel.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const API_URL = "https://kirtepan-backend-5f2b71eaf03c.herokuapp.com";

function decodeJWT(token) {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload;
    } catch (e) {
        return null;
    }
}

export default function OwnerPanel() {
    const [userProfile, setUserProfile] = useState({ name: '', surname: '', email: '' });
    const [loading, setLoading] = useState(true);
    const [token] = useState(localStorage.getItem('token'));
    const [pansion, setPansion] = useState(null);
    const [rooms, setRooms] = useState([]);
    const [activeTab, setActiveTab] = useState('pansiyonum');
    const [viewMode, setViewMode] = useState('');
    const [editRoomUid, setEditRoomUid] = useState(null);
    const [roomName, setRoomName] = useState('');
    const [roomDesc, setRoomDesc] = useState('');
    const [reservations, setReservations] = useState([]);
    const [editingRoom, setEditingRoom] = useState(null);


    //Onayla veya Sil
    const handleReservationUpdate = async (reservationUid, status) => {
        try {
            await axios.patch(
                `${API_URL}/bookings/${reservationUid}`,
                { status },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            toast.success(`Rezervasyon ${status ? 'onaylandı' : 'reddedildi'}`);
            fetchReservations(); // Listeyi güncelle
        } catch (error) {
            toast.error("Rezervasyon güncellenemedi.");
            console.error(error);
        }
    };



    const handleDeletePansion = async () => {
        if (!window.confirm("Bu pansiyonu silmek istediğinize emin misiniz?")) return;

        try {
            await axios.delete(`${API_URL}/accommodations/${pansion.uid}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Pansiyon başarıyla silindi.");
            setPansion(null);
            setRooms([]);
        } catch (error) {
            toast.error("Pansiyon silinirken bir hata oluştu.");
            console.error(error);
        }
    };

    useEffect(() => {
        if (token && activeTab === 'rezervasyonlar') {
            fetchReservations();
        }
    }, [token, activeTab]);

    const fetchReservations = async () => {
        try {
            const res = await axios.get(`${API_URL}/bookings/accommodation`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = res.data?.data || [];
            setReservations(data);
        } catch (err) {
            toast.error("Rezervasyonlar alınamadı.");
        }
    };


    useEffect(() => {
        if (token) {
            const decoded = decodeJWT(token);
            if (decoded) {
                setUserProfile({
                    name: decoded.name || '',
                    surname: decoded.surname || '',
                    email: decoded.email || '',
                    uid: decoded.uid || ''
                });
            }
            fetchAccommodation();
        }
    }, [token]);

    const fetchAccommodation = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${API_URL}/accommodations/user`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = res.data.data;
            if (data) {
                setPansion({
                    uid: data.uid,
                    name: data.name,
                    phoneNumber: data.phoneNumber,
                    city: data.city?.name || "Şehir belirtilmemiş",
                    district: data.town?.name || "İlçe belirtilmemiş",
                    village: data.village?.name || "Köy belirtilmemiş",
                    description: data.description || "Açıklama yok",
                    image: "https://picsum.photos/600/400"
                });
                const units = (data.units || []).map(unit => ({
                    uid: unit.uid,
                    name: unit.name,
                    description: unit.description,
                    price: 0,
                    images: [`https://picsum.photos/300/200?random=${unit.uid}`]
                }));
                setRooms(units);
            } else {
                setPansion(null);
            }
        } catch (err) {
            toast.error("Pansiyon bilgileri alınamadı");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p className="text-center mt-10">Yükleniyor...</p>;
    return (
        <div className="flex min-h-screen bg-gray-50">
            <ToastContainer position="top-right" autoClose={3000} />


            {/* Sol Menü */}
            <aside className="w-64 bg-gradient-to-b from-[#241c15] via-[#523323] to-[#7F6B52] shadow-xl flex flex-col p-0">
                <div className="px-6 py-8 border-b border-[#7F6B52] flex flex-col items-center gap-2">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] flex items-center justify-center text-2xl font-bold text-white shadow-inner mb-2">
                        {userProfile.name[0]}
                    </div>
                    <div className="text-lg font-bold text-[#F9D923]">Sahip Paneli</div>
                    <div className="text-xs text-[#FF914D] break-all text-center">{userProfile.email}</div>
                </div>
                <nav className="flex-1 flex flex-col gap-1 mt-4 px-2">
                    <button onClick={() => setActiveTab('pansiyonum')} className={`flex items-center gap-3 w-full px-5 py-3 rounded-lg font-semibold transition-all duration-200 text-base group ${activeTab === 'pansiyonum' ? 'bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] shadow border-l-4 border-[#F9D923] text-[#241c15]' : 'text-white hover:bg-[#523323] hover:shadow'}`}>Pansiyonum</button>
                    <button onClick={() => setActiveTab('rezervasyonlar')} className={`flex items-center gap-3 w-full px-5 py-3 rounded-lg font-semibold transition-all duration-200 text-base group ${activeTab === 'rezervasyonlar' ? 'bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] shadow border-l-4 border-[#F9D923] text-[#241c15]' : 'text-white hover:bg-[#523323] hover:shadow'}`}>Rezervasyonlar</button>
                    <button onClick={() => setActiveTab('ayarlar')} className={`flex items-center gap-3 w-full px-5 py-3 rounded-lg font-semibold transition-all duration-200 text-base group ${activeTab === 'ayarlar' ? 'bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] shadow border-l-4 border-[#F9D923] text-[#241c15]' : 'text-white hover:bg-[#523323] hover:shadow'}`}>Ayarlar</button>
                    <button onClick={() => window.location.reload()} className="flex items-center gap-3 w-full px-5 py-3 rounded-lg font-semibold transition-all duration-200 text-base group text-white hover:bg-[#523323] hover:shadow">Çıkış Yap</button>
                </nav>
            </aside>

            {/* İçerik */}
            <main className="flex-1 p-8 overflow-auto">
                {activeTab === 'pansiyonum' && !pansion && (
                    <div className="max-w-xl mx-auto text-center mt-10 space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">Henüz bir pansiyonunuz yok.</h2>
                        <button
                            onClick={() => setViewMode('addPansion')}
                            className="bg-[#F9D923] text-white px-6 py-2 rounded-lg font-semibold hover:bg-[#FF914D] transition"
                        >
                            Pansiyon Ekle
                        </button>
                    </div>
                )}

                {viewMode === 'addPansion' && (
                    <AddPansionForm token={token} userProfile={userProfile} onSuccess={() => {
                        setViewMode('');
                        fetchAccommodation();
                    }} />
                )}

                {viewMode === 'addRoom' && (
                    <AddRoomForm
                        token={token}
                        pansionUid={pansion.uid}
                        onSuccess={() => {
                            setViewMode('');
                            fetchAccommodation();
                        }}
                    />
                )}

                {editingRoom && (
                    <EditRoomForm
                        token={token}
                        room={editingRoom}
                        onSuccess={() => {
                            setEditingRoom(null);
                            fetchAccommodation();
                        }}
                    />
                )}





                {activeTab === 'pansiyonum' && pansion && (
                    <div className="max-w-4xl mx-auto w-full space-y-8">
                        {/* Pansiyon Kartı */}
                        <div className="bg-white rounded-2xl shadow-2xl flex flex-col md:flex-row items-center md:items-start gap-8 p-8 border border-gray-100">
                            <img src={pansion.image} alt="pansion" className="w-full max-w-xs h-56 object-cover rounded-xl shadow mb-4 md:mb-0" />
                            <div className="flex-1 flex flex-col gap-2">
                                <h3 className="text-3xl font-bold text-[#F9D923] mb-1">{pansion.name}</h3>
                                <div className="text-gray-600 text-lg">{pansion.city} / {pansion.district}</div>
                                <div className="mb-4 text-gray-700">{pansion.description}</div>
                                <div className="flex gap-4 mt-2">
                                    <button className="bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] text-white px-6 py-2 rounded-lg font-semibold hover:scale-105 transition" onClick={() => setViewMode('addRoom')}>Oda Ekle</button>
                                    <button
                                        className="bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] text-white px-6 py-2 rounded-lg font-semibold hover:scale-105 transition"
                                        onClick={handleDeletePansion}
                                    >
                                        Pansiyonu Sil
                                    </button>                                </div>
                            </div>
                        </div>

                        {/* Oda Listesi */}
                        <div>
                            <h4 className="text-2xl font-bold mb-4 text-gray-800">Odalar</h4>
                            <div className="flex gap-6 overflow-x-auto pb-2">
                                {rooms.length === 0 && <div className="text-gray-400 italic">Henüz oda eklenmedi.</div>}
                                {rooms.map((room) => (
                                    <div key={room.uid} className="bg-white shadow-lg rounded-2xl w-72 min-w-[270px] flex flex-col items-center border border-gray-100 hover:shadow-2xl transition p-4 relative group">
                                        <img src={room.images[0]} alt="room" className="w-full h-36 object-cover rounded-xl mb-2" />
                                        <div className="font-semibold text-lg text-gray-800 mt-2">{room.name}</div>
                                        <div className="flex gap-2 mt-3">
                                            <button
                                                className="bg-[#F9D923] text-white px-3 py-1 rounded-lg hover:bg-[#FF914D] transition"
                                                onClick={() => setEditingRoom(room)}
                                            >
                                                Düzenle
                                            </button>


                                            <button className="bg-[#F9D923] text-white px-3 py-1 rounded-lg hover:bg-[#FF914D] transition">Sil</button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}


                {activeTab === 'rezervasyonlar' && (
                    <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-[#F9D923]">Rezervasyonlar</h2>

                        {reservations.length === 0 ? (
                            <div className="bg-white p-6 rounded-xl shadow text-center text-gray-500">
                                Henüz rezervasyon bulunmamaktadır.
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {reservations.map((rsv) => (
                                    <div key={rsv.uid} className="bg-white rounded-xl shadow p-5">
                                        <h3 className="text-xl font-bold text-gray-800 mb-2">
                                            {rsv.unit?.name || 'Oda Adı Yok'}
                                        </h3>
                                        <p className="text-gray-600">
                                            <strong>Giriş:</strong> {new Date(rsv.startDate).toLocaleDateString()}
                                        </p>
                                        <p className="text-gray-600">
                                            <strong>Çıkış:</strong> {new Date(rsv.endDate).toLocaleDateString()}
                                        </p>
                                        <p className="text-gray-600">
                                            <strong>Kişi Sayısı:</strong> {rsv.customerCount}
                                        </p>
                                        <p className={`text-sm font-semibold mt-2 ${rsv.status ? 'text-green-600' : 'text-red-600'}`}>
                                            {rsv.status ? "Onaylandı" : "Bekliyor / İptal"}
                                        </p>

                                        {/* ✅ EKLENEN BUTONLAR */}
                                        <div className="mt-3 flex gap-3">
                                            <button
                                                onClick={() => handleReservationUpdate(rsv.uid, true)}
                                                className="bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600 text-sm"
                                            >
                                                Onayla
                                            </button>
                                            <button
                                                onClick={() => handleReservationUpdate(rsv.uid, false)}
                                                className="bg-red-500 text-white px-4 py-1 rounded hover:bg-red-600 text-sm"
                                            >
                                                Reddet
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'ayarlar' && (
                    <div className="max-w-lg mx-auto mt-12 space-y-8">
                        <div className="bg-white rounded-2xl shadow-xl p-8 flex flex-col items-center gap-2">
                            <div className="w-24 h-24 rounded-full bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] flex items-center justify-center text-3xl font-bold text-white mb-4 shadow-inner">
                                {userProfile.name[0]}{userProfile.surname[0]}
                            </div>
                            <div className="text-2xl font-bold text-[#F9D923] mb-1">{userProfile.name} {userProfile.surname}</div>
                            <div className="text-gray-600 text-lg mb-2">{userProfile.email}</div>
                        </div>
                        <div className="bg-white rounded-2xl shadow-xl p-8 text-center text-gray-500">Ayarlar burada olacak.</div>
                    </div>
                )}
            </main>
        </div>
    );
}

// Yeni Pansiyon Ekleme Formu
function AddPansionForm({ token, userProfile, onSuccess }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [cityName, setCityName] = useState('');
    const [townName, setTownName] = useState('');
    const [loading, setLoading] = useState(false);

    const handleCreate = async () => {
        if (!name || !description || !phoneNumber || !cityName || !townName) {
            alert("Lütfen tüm alanları doldurun.");
            return;
        }

        setLoading(true);
        try {
            await axios.post(
                `${API_URL}/accommodations`,
                {
                    name,
                    description,
                    phoneNumber,
                    cityName,
                    townName,
                    userUid: userProfile.uid,
                },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            alert("Pansiyon başarıyla oluşturuldu!");
            onSuccess();
        } catch (err) {
            alert("Pansiyon oluşturulurken hata oluştu.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-xl mx-auto bg-white rounded-xl shadow-xl p-6 space-y-4 mt-10">
            <h2 className="text-xl font-bold text-[#F9D923] text-center">Yeni Pansiyon Oluştur</h2>
            <input type="text" placeholder="Pansiyon Adı" value={name} onChange={e => setName(e.target.value)} className="w-full border px-4 py-2 rounded" />
            <input type="text" placeholder="Açıklama" value={description} onChange={e => setDescription(e.target.value)} className="w-full border px-4 py-2 rounded" />
            <input type="text" placeholder="Telefon Numarası" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} className="w-full border px-4 py-2 rounded" />
            <input type="text" placeholder="Şehir" value={cityName} onChange={e => setCityName(e.target.value)} className="w-full border px-4 py-2 rounded" />
            <input type="text" placeholder="İlçe" value={townName} onChange={e => setTownName(e.target.value)} className="w-full border px-4 py-2 rounded" />
            <button onClick={handleCreate} disabled={loading} className="w-full bg-[#F9D923] text-white font-semibold py-2 rounded hover:bg-[#FF914D] transition">
                {loading ? 'Gönderiliyor...' : 'Oluştur'}
            </button>
        </div>
    );
}

function EditRoomForm({ token, room, onSuccess }) {
    const [name, setName] = useState(room.name);
    const [description, setDescription] = useState(room.description);
    const [loading, setLoading] = useState(false);

    const handleUpdate = async () => {
        if (!name || !description) {
            alert("Tüm alanları doldurun.");
            return;
        }

        setLoading(true);
        try {
            await axios.put(`${API_URL}/units/${room.uid}`, {
                name,
                description,
                isActive: true
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            alert("Oda başarıyla güncellendi!");
            onSuccess();
        } catch (err) {
            alert("Oda güncellenemedi.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-xl mx-auto bg-white rounded-xl shadow-xl p-6 space-y-4 mt-10">
            <h2 className="text-xl font-bold text-[#F9D923] text-center">Odayı Düzenle</h2>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="w-full border px-4 py-2 rounded" placeholder="Oda Adı" />
            <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} className="w-full border px-4 py-2 rounded" placeholder="Açıklama" />
            <button
                onClick={handleUpdate}
                disabled={loading}
                className="w-full bg-[#F9D923] text-white font-semibold py-2 rounded hover:bg-[#FF914D] transition"
            >
                {loading ? "Güncelleniyor..." : "Kaydet"}
            </button>
        </div>
    );
}

function AddRoomForm({ token, pansionUid, onSuccess }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);

    const handleCreate = async () => {
        if (!name || !description) {
            alert("Lütfen tüm alanları doldurun.");
            return;
        }

        setLoading(true);
        try {
            await axios.post(`${API_URL}/units`, {
                name,
                description,
                isActive: true,
                accommodationUid: pansionUid
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            alert("Oda başarıyla eklendi!");
            onSuccess();
        } catch (err) {
            alert("Oda eklenirken hata oluştu.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-xl mx-auto bg-white rounded-xl shadow-xl p-6 space-y-4 mt-10">
            <h2 className="text-xl font-bold text-[#F9D923] text-center">Yeni Oda Ekle</h2>
            <input type="text" value={name} onChange={e => setName(e.target.value)} className="w-full border px-4 py-2 rounded" placeholder="Oda Adı" />
            <input type="text" value={description} onChange={e => setDescription(e.target.value)} className="w-full border px-4 py-2 rounded" placeholder="Açıklama" />
            <button
                onClick={handleCreate}
                disabled={loading}
                className="w-full bg-[#F9D923] text-white font-semibold py-2 rounded hover:bg-[#FF914D] transition"
            >
                {loading ? 'Ekleniyor...' : 'Oluştur'}
            </button>
        </div>
    );
}
